export default {"src":"/_next/static/media/0xB1191F691A355b43542Bea9B8847bc73e7Abb137.3c7725e8.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};